import React, { useState, useEffect } from 'react';

import { Grid } from '@mui/material';

import electronLogo1 from '../../../../assets/healthcare.png'; // Ensure these are the correct paths
import electronLogo2 from '../../../../assets/appollo.png';
import electronLogo3 from '../../../../assets/flag.png';
import electronLogo4 from '../../../../assets/icon (2).svg';
import electronLogo5 from '../../../../assets/tgicon.png';
import electronLogo6 from '../../../../assets/uaeflag.png';
import FormCard from './FormCard';
import FormDetails from './FormDetails';
import { fetchForms, submitAnswers } from './NhsstrokeService';
import { Form } from '../../../../components/interface/AssessmentInterface';
import LoadingAnimation from '../../../../components/LoadingAnimation';

const StrokeScaleForm: React.FC<{ patientId: string }> = ({ patientId }) => {
 
  const [forms, setForms] = useState<Form[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'info' | 'warning' | 'error'>('info');
  const [selectedForm, setSelectedForm] = useState<Form | null>(null);
  const [isstartMode, setIsstartMode] = useState(false);
  const [formAnswers, setFormAnswers] = useState<{ [key: string]: string }>({});

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Define the colors for the cards
  const cardColors = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'];

  

  const loadForms = async () => {
    setIsLoading(true);
    try {
      const formsData = await fetchForms(patientId);
      setForms(formsData);
    } catch (error) {
      setSnackbarMessage('Error fetching form data. Please try again later.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { loadForms(); }, [patientId]);

  const handleBack = () => { setSelectedForm(null); loadForms(); };
  const handleInputChange = (questionId: number | string, value: string) => {
    setFormAnswers(prev => ({ ...prev, [String(questionId)]: value }));
  };

  const handleSave = async () => {
    if (!selectedForm) return;

    const answers = selectedForm.questions.reduce((acc, question) => {
      const selectedAnswerId = formAnswers[question.question.id];

      // Handle main question answer
      if (selectedAnswerId) {
        acc[question.question.id] = {
          question_id: question.question.id,
          answer_id: Number(selectedAnswerId),
          jump_to_question_id: null,
          score: 1,
          order: null,
          type: "ordinary",
          label: null,
          answer: {
            id: Number(selectedAnswerId),
            name: question.answers.find((a) => a.answer.id === Number(selectedAnswerId))?.answer.name || '',
            is_active: 1,
            created_at: null,
            updated_at: null,
          },
        };
      }

      // Handle sub-questions
      if (question.question.sub_questions) {
        question.question.sub_questions.forEach(subQuestion => {
          const subAnswerId = formAnswers[subQuestion.id];
          if (subAnswerId) {
            acc[subQuestion.id] = {
              question_id: question.question.id,
              answer_id: Number(subAnswerId),
              jump_to_question_id: null,
              score: 1,
              order: null,
              type: "ordinary",
              label: null,
              answer: {
                id: Number(subAnswerId),
                name: question.answers.find((a) => a.answer.id === Number(selectedAnswerId))?.answer.name || '',
                is_active: 1,
                created_at: null,
                updated_at: null,
              },
            };
          }
        });
      }

      if (question.question.type === 'input') {
        const inputAnswer = formAnswers[question.question.id];
        if (inputAnswer) {
          acc[question.question.id] = inputAnswer;
        }
      }
      return acc;
    }, {} as Record<string, any>);

    const payload = {
      answers,
      form_id: selectedForm.id,
      form_name: selectedForm.name,
      patient_id: patientId,
    };

    try {
      const response = await submitAnswers( payload);

      if (!response) {
        throw new Error("No response received from the server");
      }
      
      if (response.status === 201) {
        setSnackbarMessage('Form submitted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        loadForms();
        setSelectedForm(null);
        setIsstartMode(false);
      }
    } catch (error) {
      setSnackbarMessage('Error submitting the form: ' + (error instanceof Error ? error.message : 'An unknown error occurred.'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleView = (formId: number) => {
    const formToView = forms.find(form => form.id === formId);
    if (formToView) {
      setSelectedForm(formToView);
      setIsstartMode(false);
    }
  };

  

  if (isLoading) {
    return <LoadingAnimation />;
  }

  return (
    <Grid container spacing={2} className='p-2'>
      {!selectedForm ? (
        forms.map((form, index) => (
          <FormCard
            key={form.id}
            form={form}
            index={index}
            cardColors={cardColors}

            handleView={handleView}

            formatDate={formatDate} handlestart={function (formId: number): void {
              throw new Error('Function not implemented.');
            } }          />
        ))
      ) : (
        <FormDetails
          form={selectedForm}
          isstartMode={isstartMode}
          handleInputChange={handleInputChange}
          handleBack={handleBack}
          handleSave={handleSave}
        />
      )}
     
    </Grid>
  );
};

export default StrokeScaleForm;
